import { DisabledPrompt, Link, useRoute } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";

import "./styles.css";

export default function AddAlertContent(props) {
    const navigate = useRoute();

    const onClick = evt => navigate("/advancedAlerts/selectAccount");

    return (
        <div className="add-alert-content back-link-padding">
            <Link to="/advancedAlerts/manageAlerts" className="back-link">
                <span><SVGAsset id="LeftChevronIcon" /> Back</span>
            </Link>

            <p className="page-subtitle">Add Alert</p>

            <div className="flex-container flex-vertical add-alerts-container">
                <DisabledPrompt>
                    <AddAlertOption text="Account Balance" />
                    <AddAlertOption text="Account Balance Above Threshold" />
                </DisabledPrompt>

                <AddAlertOption text="Account Balance Below Threshold" onClick={ onClick } />

                <DisabledPrompt>
                    <AddAlertOption text="Account status changed" />
                    <AddAlertOption text="ACH Withdrawal (debit) over threshold amount" />
                    <AddAlertOption text="CD is approaching maturity" />
                    <AddAlertOption text="Check number XXXX cleared" />
                    <AddAlertOption text="Credit transaction was posted" />
                    <AddAlertOption text="Debit transaction was posted" />
                    <AddAlertOption text="EFT authorization hold added" />
                    <AddAlertOption text="Fee was Charged to an Account" />
                    <AddAlertOption text="Incoming transfer over threshold amount" />
                    <AddAlertOption text="Initial deposit was posted to Time Deposit account" />
                    <AddAlertOption text="Interest was paid to an account" />
                    <AddAlertOption text="Loan advance was posted" />
                    <AddAlertOption text="Outgoing transfer over threshold amount" />
                    <AddAlertOption text="Payment was posted to a loan" />
                    <AddAlertOption text="Transaction equal to threshold amount" />
                    <AddAlertOption text="Transaction over threshold amount" />
                    <AddAlertOption text="Withdrawal over threshold amount occured" />
                </DisabledPrompt>
            </div>
        </div>
    );
}

function AddAlertOption(props) {
    return (
        <div className="flex-container flex-horizontal alert-option clickable" onClick={ props.onClick }>
            <p className="flex-width">{ props.text }</p>
            <SVGAsset id="RightChevronIcon" className="set-width" />
        </div>
    );
}